import React, {useEffect, useState} from 'react';

const CardProduct = ({dealProduct = [], setDealProduct, products1C = [], className = '', style = {}}) => {

    let totalPrice = 0

    return (
        <div className={"row " + className} style={style}>
            <div className="col">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Код</th>
                            <th scope="col">Товар</th>
                            <th scope="col">Количество</th>
                            <th scope="col">Цена</th>
                            <th scope="col">Сумма</th>
                            <th scope="col">Остаток</th>
                        </tr>
                    </thead>
                    <tbody id="deal_products">
                        {dealProduct.map((item, index) => {
                            const price = item.NEW_PRICE ? item.NEW_PRICE : item.PRICE

                            const product = products1C.find(product => product.XML_ID === item.XML_ID)

                            const priceError = product && item.NEW_PRICE && item.NEW_PRICE < product.PRICE_OPT

                            totalPrice += item.COUNT * price;

                            return (
                                <tr key={index}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{item?.CODE ?? product?.CODE}</td>
                                    <td>{item.NAME}</td>
                                    <td>
                                        <input className="form-control" value={item.COUNT}
                                               onChange={(event => {
                                                   setDealProduct(dealProduct.map((prevItem, prevIndex) => {
                                                       if (prevIndex === index) {
                                                           return {...prevItem, COUNT: event.target.value}
                                                       }
                                                       return prevItem
                                                   }))
                                               })}/>
                                    </td>
                                    <td>
                                        <input className="form-control" value={price}
                                               onChange={(event => {
                                                   setDealProduct(dealProduct.map((prevItem, prevIndex) => {
                                                       if (prevIndex === index) {
                                                           return {...prevItem, NEW_PRICE: event.target.value}
                                                       }
                                                       return prevItem
                                                   }))
                                               })}/>
                                        {!!priceError && (<span className="invalid-feedback">Цена меньше оптовой</span>)}
                                    </td>
                                    <td>{new Intl.NumberFormat("ru").format(item.COUNT * price)}</td>
                                    <td>{product?.QUANTITY}</td>
                                    <td>
                                        <button className="btn-close" onClick={() => {
                                            setDealProduct(dealProduct.filter((prevItem, prevIndex) => prevIndex !== index))
                                        }}/>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="8" className="text-end">Общая сумма заказа: <span id="total_summ">{new Intl.NumberFormat("ru").format(totalPrice)}</span>руб</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    )
}

export default CardProduct